{
  "automations": {
    "navigation_title": "Automations",
    "title": "Automations",
    "hvac": {
      "navigation_title": "HVAC",
      "title": "HVAC"
    },
    "rule_1466": {
      "navigation_title": "Rule 1466",
      "title": "Rule 1466"
    }
  }
}
